import App_data from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';
import PostData from '../../../RestAPI/fetchData';

const fetchNotes = async data => {
  return await GetData.callAPI(`${App_data.backend_api}/exams/cfa/notes/all-notes`, data);
};
const fetchSavedQuestion = async data => {
  return await GetData.callAPI(`${App_data.backend_api}/exams/cfa/notes/save-notes`, {
    ...data,
    notesId: data.question_id,
  });
};
const saveQuestion = async data => {
  return await PostData.callAPI(`${App_data.backend_api}/exams/cfa/notes/save-notes`, {
    ...data,

    notesId: data.question_id,
  });
};
const deleteSavedQuestion = async data => {
  return await PostData.callAPI(`${App_data.backend_api}/exams/cfa/notes/unsave-notes`, {
    ...data,
    notesId: data.question_id,
  });
};
const fetchNotesStats = async data => {
  return await GetData.callAPI(`${App_data.backend_api}/exams/cfa/notes/save-stats`, {notesId: data.id,});
};
const saveNotesStats = async data => {
  return await PostData.callAPI(`${App_data.backend_api}/exams/cfa/notes/save-stats`, {notesId: data.id,});
};
const reportQuestion = async data => {
  return await PostData.callAPI(`${App_data.backend_api}/exams/cfa/notes/report-notes`, {
    notesId: data.questionId,
    ...data,
  });
};
module.exports = {
  fetchNotes,
  fetchSavedQuestion,
  deleteSavedQuestion,
  saveQuestion,
  fetchNotesStats,
  saveNotesStats,
  reportQuestion,
};



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/View/ApiService.js